import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  AccessExportRequest,
  AccessGroup,
  AccessGroupMembers,
  AccessMultiGroupMember,
  AccessOrphanEmployee
} from '../models/access-group.model';
import { AccessRole } from '../models/access-matrix.model';

/**
 * Entra group membership behind each access role. Admin-only on the server; the backend
 * caches the directory reads and `refresh` forces a re-read.
 */
@Injectable({ providedIn: 'root' })
export class AccessGroupService {
  private apiUrl = `${environment.apiUrl}/Access`;

  constructor(private http: HttpClient) {}

  getGroups(refresh = false): Observable<AccessGroup[]> {
    return this.http.get<AccessGroup[]>(`${this.apiUrl}/groups`, {
      params: new HttpParams().set('refresh', refresh)
    });
  }

  getMembers(role: AccessRole, refresh = false): Observable<AccessGroupMembers> {
    return this.http.get<AccessGroupMembers>(`${this.apiUrl}/groups/${role}/members`, {
      params: new HttpParams().set('refresh', refresh)
    });
  }

  getUngroupedEmployees(refresh = false): Observable<AccessOrphanEmployee[]> {
    return this.http.get<AccessOrphanEmployee[]>(`${this.apiUrl}/ungrouped-employees`, {
      params: new HttpParams().set('refresh', refresh)
    });
  }

  /** People holding more than one access role, resolved server-side across all groups. */
  getMultiGroupMembers(): Observable<AccessMultiGroupMember[]> {
    return this.http.get<AccessMultiGroupMember[]>(`${this.apiUrl}/multi-group-members`);
  }

  /** Styled .xlsx built server-side; the browser only saves the blob. */
  exportExcel(request: AccessExportRequest): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/export-excel`, request, { responseType: 'blob' });
  }
}
